import { defineStore } from 'pinia'

export const useConfigStore = defineStore('configStore', {
  state: () => {
    return {
      appConfig: undefined as any,
      appData: undefined as any,
      customConfig: undefined as any,
      first:{
        param:undefined as any,
        error:undefined as any
      },
      second:{
        param:undefined as any,
        error:undefined as any
      },
      third:{
        param:undefined as any,
        error:undefined as any
      },
      jsonData:{
        param:undefined as any,
        error:undefined as any
      },
      domainData:{
        param:undefined as any,
        error:undefined as any
      }
    }
  },
  actions: {},
  getters: {},
  // 开始数据持久化
  // persist: process.client && {
  //   key: 'configStore',
  //   storage: window.sessionStorage
  // }
})
